var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-box posi-relative"},[_c('p',{class:{'txt-center-noTitle':!_vm.title}},[_c('img',{attrs:{"src":require("../../assets/img/register-icon-success.png")}})]),_vm._v(" "),_c('p',{staticClass:"posi-absolute"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c078456c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseCpts/resultSuccess.vue
// module id = null
// module chunks = 